import store from '../redux/store';

const getRelationalOrgByOrgId = (orgId) => {
  const orgList = store.getState().omniDetails?.listsupplierbuyer;
  let returnOrg = {};
  orgList?.OrganizationList?.some((ele) => {
    if (ele?.organization?.orgId === Number(orgId)) {
      returnOrg = ele?.organization;
      return true;
    }
    return false;
  });

  if (!returnOrg?._id) {
    orgList?.buyerSupplierGroupList?.forEach((ele) => {
      ele?.list?.forEach((org) => {
        if (Number(org?.orgId) === Number(orgId)) {
          returnOrg = org;
          return true;
        }
        return false;
      });
    });
  }
  return returnOrg;
};

export default getRelationalOrgByOrgId;
